import React, { Component } from "react";

import MusicList from "./MusicList";
import { API_URL } from '../../Config';

export default class Playlists extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null
    };
  }

  componentWillMount() {
    this.props.setMenuIndex();
  }

  componentDidMount() {
    this.props.updateData()
  }

  changeCollection(id) {
    const currentZone = window.persistence.local.get("currentZone").token;
    fetch(`${API_URL}/zone?token=${currentZone}`, {
      method: "PATCH",
      body: JSON.stringify({
        action: "setPlayFrom",
        id: id
      })
    })
      .then(response => response.json())
      .catch(error => console.error("Error", error))
      .then(response => {
        this.props.history.push("/player");
      });
  }

  render() {
    return (
      <div>
        {this.props.data && (
          <MusicList
            collections={this.props.data}
            currentPlayFrom={this.props.currentPlayFrom}
            changeCollection={(id) => this.changeCollection(id)}
            name="playlists"
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Views/ChangeMusic/Playlists.js